import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-summary-criteria',
  templateUrl: './summary-criteria.component.html',
  styleUrls: ['./summary-criteria.component.scss']
})
export class SummaryCriteriaComponent implements OnInit {

  // evicences = ['a','b','c']

  @Input('quizDetails') quizDetails;
  @Input('evidences') evidences;
  @Output() criteriaEvidenceList: EventEmitter<any> = new EventEmitter<any>();

  criteriaEvidence = [];

  constructor() { }

  ngOnInit() {
    console.log('evicences', this.evidences)
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log("CHANGES", changes);

    if (changes.evidences) {
      this.evidences = changes.evidences.currentValue
      // console.log('%cevidences', "color:pink", this.evidences)
    }

    if (changes.quizDetails) {
      this.quizDetails = changes.quizDetails.currentValue;
      this.quizDetails.quizCriteria.forEach(singleCriteria => {
        singleCriteria.list.forEach(singleList => {
          // console.log("inside for loog", singleList);
          if (singleList.evidence) {
            let event = {
              value: singleList.evidence
            }
            this.evidenceSelected(event, singleList, singleCriteria);
          }
        })
      })
    }
  }

  evidenceSelected(event, singleList, singleCriteria) {
    // console.log("%cEVENT", "color:orange", event)
    // console.log("%csingleList", "color:brown", singleList)
    let obj = {
      criteriaId: singleCriteria._id,
      criteriaListId: singleList._id,
      evidenceId: event.value
    }
    let index = _.findIndex(this.criteriaEvidence, function (o) { return o.criteriaListId == singleList._id })
    if (index > -1) {
      this.criteriaEvidence[index] = obj
    }
    else {
      this.criteriaEvidence.push(obj)
    }

    this.criteriaEvidenceList.emit(this.criteriaEvidence)
  }
}
